import { render, staticRenderFns } from "./UnderlineTabs.vue?vue&type=template&id=52dff240&"
import script from "./UnderlineTabs.vue?vue&type=script&lang=js&"
export * from "./UnderlineTabs.vue?vue&type=script&lang=js&"
import style0 from "./UnderlineTabs.vue?vue&type=style&index=0&id=52dff240&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports